"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateInvoiceTotals = exports.calculateInvoiceTaskTotals = void 0;
const round = (number) => Math.round(number * 100) / 100;
const calculateInvoiceTaskTotals = (invoiceTask) => {
    const { unitPrice, units, vatPercentage } = invoiceTask;
    const totalAmountBeforeTaxes = round(unitPrice * units);
    return {
        totalAmountBeforeTaxes,
        totalVatAmount: round(totalAmountBeforeTaxes * (vatPercentage / 100)),
    };
};
exports.calculateInvoiceTaskTotals = calculateInvoiceTaskTotals;
const calculateInvoiceTotals = (invoiceTasksWithTotals) => {
    const { tasksBeforeTaxesSum, tasksVatAmountSum } = invoiceTasksWithTotals.reduce((acc, task) => ({
        tasksBeforeTaxesSum: acc.tasksBeforeTaxesSum + task.totalAmountBeforeTaxes,
        tasksVatAmountSum: acc.tasksVatAmountSum + task.totalVatAmount,
    }), { tasksBeforeTaxesSum: 0, tasksVatAmountSum: 0 });
    const totalAmountBeforeTaxes = round(tasksBeforeTaxesSum);
    const totalVatAmount = round(tasksVatAmountSum);
    const totalAmountAfterTaxes = round(totalAmountBeforeTaxes + totalVatAmount);
    return {
        totalAmountAfterTaxes,
        totalAmountBeforeTaxes,
        totalVatAmount,
    };
};
exports.calculateInvoiceTotals = calculateInvoiceTotals;
